import { defineMessages } from '@jutro/locale';

export default defineMessages({
    anErrorOccurred: {
        id: 'quoteandbind.pa.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.pa.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    saveQuoteError: {
        id: 'quoteandbind.pa.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.pa.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    prefillResults: {
        id: 'ml.quoteandbind.pa.wizard.step.prefillResults',
        defaultMessage: 'Prefill Results'
    },
    customerDetails: {
        id: 'ml.quoteandbind.pa.wizard.step.Customer Details',
        defaultMessage: 'Customer Details'
    },
    infoWillNotBeSaved: {
        id: 'ml.quoteandbind.pa.wizard.infoWillNotBeSaved',
        defaultMessage: 'The information you have entered will not be saved'
    },
    generalInfo: {
        id: 'ml.quoteandbind.pa.wizard.General Info',
        defaultMessage: 'General Info'
    },
    purchase: {
        id: 'ml.quoteandbind.pa.wizard.Purchase',
        defaultMessage: 'Purchase'
    },
    crGroupAffiliation: {
        id: "ml.quoteandbind.wizard.step.CR Group Account/Affiliation",
        defaultMessage: "Group Account/Affiliation"
    }, 
    crGroupDiscounts: {
        id: "ml.quoteandbind.wizard.step.CR Group Discounts",
        defaultMessage: "Group Discounts"
    }, 
    crPrefillResults: {
        id: "ml.quoteandbind.wizard.step.CR Prefill Results",
        defaultMessage: "Prefill Results"
    },
    crDrivers: {
        id:"ml.quoteandbind.pa.wizard.step.CR Drivers",
        defaultMessage: "Drivers"
    },
    crVehicles: {
        id: "ml.quoteandbind.pa.wizard.step.CR Vehicles",
        defaultMessage: "Vehicles"
    },
    crValidateInformation: {
        id: "ml.quoteandbind.pa.wizard.step.CR Validate Information",
        defaultMessage: "Validate Information"
    },
    crQuoteResults: {
        id: "ml.quoteandbind.wizard.step.CR Quote Results",
        defaultMessage: "Quote Results"
    }
});
